import clsx from "clsx"
import { FC } from "react"
import { InfoIcon } from "@/assets"
import { Button } from "@/ui/Button"
import styles from "./ButtonInfo.module.scss"
import { IButtonInfo } from "./types"

export const ButtonInfo: FC<IButtonInfo> = ({ className, ...props }) => {
  return (
    <Button
      icon={<InfoIcon />}
      className={clsx(styles.ButtonInfo, className)}
      {...props}
    />
  )
}
